import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const currentDate = new Date(dayjs(new Date()).format("MM/DD/YYYY"));

const initialState = {
  filterValues: {
    branchArray: [],
    branch: null,
    applicationArray: [],
    applicationNum: null,
    customerName: "",
    customerId: "",
    effectiveDate: currentDate,
    loanBalance: "0",
    rateOfInterest: "",
    currentEmi: "0",
    revisedEmi: "",
    currentTenure: "",
    revisedTenure: "",
    reason: "",
  },

  touchHandler: {
    branchTouched: false,
    applicationNumTouched: false,
    revisedTenureTouched: false,
    revisedEmiTouched: false,
    effectiveDateTouched: false,
    reasonTouched: false,
  },

  valueIsValid: {
    branchIsValid: false,
    applicationNumIsValid: false,
    revisedTenureIsValid: false,
    revisedEmiIsValid: false,
    effectiveDateIsValid: true,
    reasonIsValid: false,
  },
};

const ReSchedulementReducer = createSlice({
  name: "reSchedulement",
  initialState: initialState,
  reducers: {
    updateBranchArray(state, action) {
      state.filterValues.branchArray = action.payload;
    },

    updateBranchValue(state, action) {
      state.filterValues.branch = action.payload;
      state.valueIsValid.branchIsValid =
        action.payload !== "" && action.payload !== null;
    },

    updateApplicationArray(state, action) {
      state.filterValues.applicationArray = action.payload;
    },

    updateLoanBalance(state, action) {
      state.filterValues.loanBalance = action.payload;
    },

    updateCurrentEmi(state, action) {
      state.filterValues.currentEmi = action.payload;
    },

    updateCurrentTenure(state, action) {
      state.filterValues.currentTenure = action.payload;
    },

    updateApplicationValue(state, action) {
      state.filterValues.applicationNum = action.payload;
      state.valueIsValid.applicationNumIsValid =
        action.payload !== "" && action.payload !== null;
    },

    updateEffectiveDate(state, action) {
      state.filterValues.effectiveDate = action.payload;
      state.valueIsValid.effectiveDateIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined &&
        action.payload >= currentDate;
    },

    updateRevisedEMIValue(state, action) {
      state.filterValues.revisedEmi = action.payload;
      state.valueIsValid.revisedEmiIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined &&
        parseInt(action.payload) > 0;
    },

    updateRevisedTenureValue(state, action) {
      state.filterValues.revisedTenure = action.payload;
      state.valueIsValid.revisedTenureIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined &&
        action.payload > 0 &&
        Number.isInteger(Number(action.payload));
    },

    updateReasonValue(state, action) {
      state.filterValues.reason = action.payload;
      state.valueIsValid.reasonIsValid =
        action.payload !== "" &&
        action.payload !== null &&
        action.payload !== undefined;
    },

    resetRevisedValues(state, action) {
      state.filterValues.revisedTenure = "";
      state.filterValues.revisedEmi = "";
      state.touchHandler.revisedEmiTouched = false;
      state.touchHandler.revisedTenureTouched = false;
      state.valueIsValid.revisedEmiIsValid = false;
      state.valueIsValid.revisedTenureIsValid = false;
      state.touchHandler.effectiveDateIsValid = false;
    },

    updateRevisedEmiIsValid(state, action) {
      state.valueIsValid.revisedEmiIsValid = action.payload;
    },

    updateRevisedTenureIsValid(state, action) {
      state.valueIsValid.revisedTenureIsValid = action.payload;
    },

    //Reducer for touch handler
    updateBranchIsTouched(state, action) {
      state.touchHandler.branchTouched = action.payload;
    },

    updateApplicationNumberIsTouched(state, action) {
      state.touchHandler.applicationNumTouched = action.payload;
    },

    updateRevisedEmiIsTouched(state, action) {
      state.touchHandler.revisedEmiTouched = action.payload;
    },

    updateRevisedTenureIsTouched(state, action) {
      state.touchHandler.revisedTenureTouched = action.payload;
    },

    updateReasonIsTouched(state, action) {
      state.touchHandler.reasonTouched = action.payload;
    },

    updateEffectiveDateIsTouched(state, action) {
      state.touchHandler.effectiveDateTouched = action.payload;
    },

    resetFilterValues(state, action) {
      state.filterValues.customerName = "";
      state.filterValues.customerId = "";
      state.filterValues.loanBalance = "0";
      state.filterValues.rateOfInterest = "";
      state.filterValues.currentEmi = "0";
      state.filterValues.currentTenure = "";
      state.filterValues.revisedEmi = "";
      state.filterValues.revisedTenure = "";
      state.filterValues.effectiveDate = currentDate;
      state.filterValues.reason = "";
    },

    updateFilterValues(state, action) {
      state.filterValues.branch = action.payload.branch;
      state.filterValues.applicationNum = action.payload.applicationNum;
      state.filterValues.customerName = action.payload.customerName;
      state.filterValues.customerId = action.payload.customerId;
      state.filterValues.loanBalance = action.payload.loanBalance;
      state.filterValues.rateOfInterest = action.payload.rateOfInterest;
      state.filterValues.currentEmi = action.payload.currentEmi;
      state.filterValues.currentTenure = action.payload.currentTenure;
    },

    resetTouchHandlers(state, action) {
      state.touchHandler = initialState.touchHandler;
      state.valueIsValid = initialState.valueIsValid;
      state.filterValues = initialState.filterValues;
    },
  },
});

export const ReShedulementReducerAction = ReSchedulementReducer.actions;
export default ReSchedulementReducer.reducer;
